// Every account dialog uses GrooveMail's maintained email sender form.
export function createAccountSenderSettingsAdapter(LegacySenderSettings, {
  navigate = url => window.location.assign(url),
} = {}) {
  if (!LegacySenderSettings) return LegacySenderSettings;
  const legacyGetDriver = LegacySenderSettings.methods && LegacySenderSettings.methods.getDriver;
  return {
    extends: LegacySenderSettings,
    methods: {
      getDriver(driver) {
        return Number(driver) === 6 ? 'Resend' : legacyGetDriver ? legacyGetDriver.call(this, driver) : 'N/A';
      },
      openCreateSetting() {
        if (this.userCanMail) navigate('/groovemail/senders/create');
        else this.showErrorForMailing();
      },
      openEditSetting(id) {
        if (this.userCanMail) navigate(`/groovemail/senders/edit/${encodeURIComponent(id)}`);
        else this.showErrorForMailing();
      },
      showRecipientModal() {
        if (this.userCanMail) navigate('/groovemail/settings?type=recipients');
        else this.showErrorForMailing();
      },
      sendOTP() {
        if (this.userCanMail) navigate('/groovemail/settings?type=recipients');
        else this.showErrorForMailing();
      },
    },
  };
}
